/**
 * answer
 */

import request from '../utils/request'

/**
 * save answer
 * @param data
 * {
    UserInfo User = 1; // 用户
    uint32 ExamID = 2; // 考试ID，非考试模式填0
    uint32 QuestionID = 3; // 题目ID
    string Answer = 4; // 答案，格式参考 CreateQuestionRequest，编程题存Base64编码后的代码
    string Comment = 5; // 注释
 * }
 * @returns {Promise<AxiosResponse<T>>}
 * {
    RpcStatus Status = 1;
 * }
 */
const save = async (data) => {
  const res = await request.httpPost('/qceit/answer/save', data)
  return res
}

/**
 * commit answer
 * @param data
 * {
    UserInfo User = 1; // 考生标示
    uint32 ExamID = 2; // 考卷ID
    uint32 QuestionID = 3; // 题目ID
    string Answer = 4; // 答案，格式同 SaveExamAnswerRequest.Answer
 * }
 * @returns {Promise<AxiosResponse<T>>}
 * {
    RpcStatus Status = 1;
 * }
 */
const commit = async (data) => {
  const res = await request.httpPost('/qceit/answer/commit', data)
  return res
}

/**
 *
 * @param data
 * { ID }
 * or
 * {
    UserID: 10,
    ExamID: this.get('ExamID') || 0,
    QuestionID: this.get('QuestionID')
   }
 * @returns {Promise<AxiosResponse<T>>}
 * {
    RpcStatus Status = 1;
    AnswerInfo Answer = 2;
 * }
 */
const getAnswer = (data) => {
  return request.httpGet('/qceit/answer/getAnswer', data)
}

const testCode = (data) => {
  return request.httpPost('/qceit/test/testCode', data)
}

const getTest = (data) => {
  return request.httpGet('/qceit/test/getTest', data)
}

const testList = (data) => {
  return request.httpGet('/qceit/test/list', data)
}



export default {
  save,
  commit,
  getAnswer,
  testCode,
  getTest,
  testList,
}
